// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toolbar_wrapper__1Or5Z"};